<div id="sidebar-container" class="sidebar-container flex flex-col justify-between" *ngIf="layoutHelper.sideNavToggleAction$ | async as toggleStatus">
  <div class="sidebar-fixed sidebar z-50" [ngClass]="{'sidebar-compact': (toggleStatus === 'closed')}">
    <nav class="sidebar-nav">
      <ul class="bs-nav">
        <li *ngFor="let routeConfig of routeConfigs" class="nav-item">
          <div class="sidebar-category">
            <div class="sidebar-category-open" *ngIf="(toggleStatus === 'open')">
              <div class="sidebar-link">
                <a *ngIf="!routeConfig.externalTool" class="bs-nav-link !pr-12" [ngClass]="{'bs-active': (layoutHelper.currentCategory === routeConfig.category)}"
                  routerLinkActive="active" [routerLink]="[routeConfig.defaultRoute]">
                  <i class="sidebar-icon" [ngClass]="routeConfig.iconClass"></i>
                  <span *ngIf="toggleStatus==='open'">{{routeConfig.displayName | translate: locale | async}}</span>
                </a>
                <a *ngIf="!!routeConfig.externalTool" class="bs-nav-link !pr-12" [ngClass]="{'bs-active': (layoutHelper.currentCategory === routeConfig.category)}"
                  routerLinkActive="active">
                  <i class="sidebar-icon" [ngClass]="routeConfig.iconClass"></i>
                  <span *ngIf="toggleStatus==='open'">{{routeConfig.displayName | translate: locale | async}}</span>
                </a>
              </div>
              <!-- Only show expand button for routes with children (non-static routes) -->
              <div class="sidebar-expand bs-nav-link -mr-4" (click)="layoutHelper.updateExpandedCategory(routeConfig.category)"
                [ngClass]="{'bs-active': (layoutHelper.currentCategory === routeConfig.category)}">
                <i class="sidebar-category-icon mat-icon material-icons pull-right"
                  [@rotate90]="layoutHelper.expandedCategory !== routeConfig.category">
                  keyboard_arrow_right
                </i>
              </div>
            </div>
            <!-- Closed sidebar: Show menu trigger only for routes with children -->
            <a *ngIf="(toggleStatus === 'closed') && !routeConfig.externalTool" class="bs-nav-link"
              [ngClass]="{'bs-active': (layoutHelper.currentCategory === routeConfig.category)}" routerLinkActive="bs-active"
              [routerLink]="[routeConfig.defaultRoute]" [matMenuTriggerFor]="currentMenu"
              #currentMenuTrigger="matMenuTrigger" id="{{routeConfig.id}}" (mouseenter)="openMenu(currentMenuTrigger)"
              style="width: 100%;">
              <i class="sidebar-icon" [ngClass]="routeConfig.iconClass"></i>
              <span *ngIf="toggleStatus==='open'">{{routeConfig.displayName | translate: locale | async}}</span>
            </a>

            <a *ngIf="(toggleStatus === 'closed') && !!routeConfig.externalTool" class="bs-nav-link"
              [ngClass]="{'bs-active': (layoutHelper.currentCategory === routeConfig.category)}" routerLinkActive="bs-active"
              [matMenuTriggerFor]="currentMenu" #currentMenuTrigger="matMenuTrigger" id="{{routeConfig.id}}" (mouseenter)="openMenu(currentMenuTrigger)"
              style="width: 100%;">
              <i class="sidebar-icon" [ngClass]="routeConfig.iconClass"></i>
              <span *ngIf="toggleStatus==='open'">{{routeConfig.displayName | translate: locale | async}}</span>
            </a>
          </div>
          <!-- Menu dropdown - only show for routes with children -->
          <mat-menu #currentMenu="matMenu" [overlapTrigger]="false" [hasBackdrop]="true"
            backdropClass="flyout-menu-backdrop" class="flyout-menu">
            <ng-template matMenuContent>
              <button class="flyout-menu-title" [disabled]="true" mat-menu-item>
                <i [ngClass]="routeConfig.iconClass"></i><span> {{routeConfig.displayName | translate: locale | async}}</span>
              </button>
              <mat-divider></mat-divider>
              <div *ngFor="let child of routeConfig.children">
                <button *ngIf="!routeConfig.externalTool" mat-menu-item routerLinkActive="bs-active" [routerLink]="[child.parent, child.route]">
                  {{child.displayName | translate: locale | async}}
                </button>
                <button *ngIf="!!routeConfig.externalTool" mat-menu-item (click)="openExternalTool(child, routeConfig.newTab)">
                  {{child.displayName | translate: locale | async}}
                </button>
              </div>
            </ng-template>
          </mat-menu>
          <!-- Expanded children - only show for routes with children -->
          <div *ngIf="toggleStatus === 'open' && layoutHelper.expandedCategory === routeConfig.category">
            <ul class="bs-nav">
              <li class="nav-item" *ngFor="let child of routeConfig.children">
                <a *ngIf="!routeConfig.externalTool" class="bs-nav-link nav-item-child" routerLinkActive="bs-active" [routerLink]="child.route ? [child.parent, child.route] : child.parent" [routerLinkActiveOptions]="{ exact: true }">
                  {{child.displayName | translate: locale | async}}
                </a>
                <a *ngIf="!!routeConfig.externalTool" class="bs-nav-link nav-item-child" (click)="openExternalTool(child, routeConfig.newTab)">
                  {{child.displayName | translate: locale | async}}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>
  <div class="sidebar-toggle pull-right" (click)="layoutHelper.toggleSidebar(toggleStatus)">
    <i class="sidebar-toggle-icon mat-icon-lg mat-icon material-icons pull-right" style="overflow: visible"
      [@rotate180]="layoutHelper.rotateMenuGlyph">
      keyboard_arrow_left
    </i>
  </div>
</div>

<!-- 
  NOTE: The `mat-icon` styles are only injected when a page actively uses <mat-icon>. 
  Since our sidebar relies on these styles without rendering <mat-icon> directly, 
  this ensures they are loaded up front to prevent unexpected style shifts 
  as users navigate through the app.
-->
<mat-icon class="hidden absolute top-0 right-0" />
